export function pleitoPostoAnexoInRequest(params = {}) {
  return {
    type: '@pleitopostoanexo/PLEITOPOSTOANEXO_IN_REQUEST',
    payload: { params },
  };
}

export function findPleitoPostoAnexo(idpleitopostoanexo) {
  return {
    type: '@pleitopostoanexo/FIND_PLEITOPOSTOANEXO',
    payload: { idpleitopostoanexo },
  };
}

export function failedRequest() {
  return {
    type: '@pleitopostoanexo/FAILED_REQUEST',
  };
}

export function deletePleitoPostoAnexo(idpleitopostoanexo, params) {
  return {
    type: '@pleitopostoanexo/DELETE_PLEITOPOSTOANEXO',
    payload: { idpleitopostoanexo, params },
  };
}

export function updatePleitoPostoAnexo(pleitopostoanexo, params) {
  return {
    type: '@pleitopostoanexo/UPDATE_PLEITOPOSTO',
    payload: { pleitopostoanexo, params },
  };
}

export function storePleitoPosto(pleitopostoanexo, params) {
  return {
    type: '@pleitopostoanexo/STORE_PLEITOPOSTO',
    payload: { pleitopostoanexo, params },
  };
}

export function successInRequest(
  pleitopostoanexos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@pleitopostoanexo/SUCCESS_IN_REQUEST',
    payload: { pleitopostoanexos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(pleitopostoanexos) {
  return {
    type: '@pleitopostoanexo/SUCCESS_REQUEST',
    payload: { pleitopostoanexos },
  };
}

export function successRemove(params) {
  return {
    type: '@pleitopostoanexo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@pleitopostoanexo/RECORD_FILTERING',
    payload: { params },
  };
}

export function resetValues() {
  return {
    type: '@pleitopostoanexo/RESET_VALUES'
  }
}
